<template>
  <div>
    <h1>{{ $t("careers.submitApplication") }}</h1>
    <b-form @submit="onSubmit">
      <b-form-group
        id="input-group-resume"
        label-for="resume"
        :label="$t('careers.resume')"
        class="required"
      >
        <b-form-file
          id="resume"
          v-model="form.resume"
          plain
          :placeholder="$t('careers.attach')"
        ></b-form-file>
      </b-form-group>

      <b-form-group
        id="input-group-fullname"
        label-for="fullname"
        :label="$t('careers.form.fullname')"
        class="required"
      >
        <b-form-input
          id="fullname"
          v-model="form.fullname"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-email"
        label-for="email"
        :label="$t('careers.form.email')"
        class="required"
      >
        <b-form-input
          id="email"
          v-model="form.email"
          type="email"
          required
        ></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-phone"
        label-for="phone"
        :label="$t('careers.form.phone')"
      >
        <b-form-input id="phone" v-model="form.phone" type="tel"></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-company"
        label-for="company"
        :label="$t('careers.form.company')"
      >
        <b-form-input id="company" v-model="form.company"></b-form-input>
      </b-form-group>

      <h5 class="text-dark">{{ $t("careers.form.links") }}</h5>

      <b-form-group
        id="input-group-facebook"
        label-for="facebook"
        :label="$t('careers.form.facebook')"
      >
        <b-form-input id="facebook" v-model="form.facebook"></b-form-input>
      </b-form-group>

      <b-form-group
        id="input-group-linkedin"
        label-for="linkedin"
        :label="$t('careers.form.linkedin')"
      >
        <b-form-input id="linkedin" v-model="form.linkedin"></b-form-input>
      </b-form-group>

      <h5 class="text-dark">{{ $t("careers.form.introduction") }}</h5>

      <b-form-group
        id="input-group-introduction"
        label-for="introduction"
        :label="$t('careers.form.tellUs')"
        class="required"
      >
        <b-form-textarea
          id="introduction"
          v-model="form.introduction"
          required
          rows="6"
          max-rows="8"
        ></b-form-textarea>
      </b-form-group>

      <b-form-group
        id="input-group-location"
        label-for="location"
        :label="$t('careers.form.location')"
        class="required"
      >
        <b-form-input
          id="location"
          v-model="form.location"
          required
        ></b-form-input>
      </b-form-group>

      <h5 class="text-dark">{{ $t("careers.form.additional") }}</h5>

      <b-form-group
        id="input-group-additional"
        label-for="additional"
        :label="$t('careers.form.coverLetter')"
      >
        <b-form-textarea
          id="additional"
          v-model="form.additional"
          rows="6"
          max-rows="8"
        ></b-form-textarea>
      </b-form-group>

      <b-button type="submit" class="btn-gold">{{
        $t("careers.form.submit")
      }}</b-button>
    </b-form>
  </div>
</template>

<script>
import {
  BButton,
  BForm,
  BFormFile,
  BFormGroup,
  BFormInput,
  BFormTextarea,
} from "bootstrap-vue";
export default {
  components: {
    BForm,
    BFormGroup,
    BFormInput,
    BButton,
    BFormTextarea,
    BFormFile,
  },
  data() {
    return {
      form: {
        resume: null,
        fullname: "",
        email: "",
        phone: "",
        company: "",
        facebook: "",
        linkedin: "",
        introduction: "",
        location: "",
        additional: "",
      },
    };
  },
  methods: {
    onSubmit(event) {
      event.preventDefault();
      this.$emit("submitted", JSON.stringify(this.form));
      //   调用API提交表单数据
      alert(JSON.stringify(this.form));
    },
  },
};
</script>

<style>
.application-form {
  h5 {
    color: #3b3e51;
    font-size: 1.3rem;
    margin: 1rem 0 2rem;
  }
  label {
    margin: 1rem 0 0.5rem;
  }
  input,
  textarea {
    background-color: #f4f9fe;
    border: none;
    margin-bottom: 1rem;
  }
  .required label::after {
    content: "*";
    color: red;
    margin-left: 0.3rem;
  }
  button.btn-gold {
    padding: 0.5rem 2rem;
    border-radius: 1.5rem;
    margin: 1rem 0;
  }
  .investment-options {
    margin-top: 2.5rem;
    display: flex;
    flex-wrap: wrap;
    justify-content: space-between;
    align-items: center;
    .custom-control {
      width: 100%;
      font-size: 1rem;
      line-height: 2rem;
      input[type="checkbox"] {
        display: none;
      }
      label {
        position: relative;
        cursor: pointer;
        padding-left: 1.6rem;
      }
      label::before {
        content: "";
        display: inline-flex;
        justify-content: center;
        align-items: center;
        position: absolute;
        left: 0;
        top: 0.3rem;
        width: 1.3rem;
        height: 1.3rem;
        border-radius: 1.3rem;
        margin-right: 0.5rem;
        background-color: transparent;
        border: 3px solid #ff00004d;
      }
      input[type="checkbox"]:checked + label:before {
        content: "\2713";
        color: white;
        font-size: 0.8rem;
        line-height: 1.3rem;
        background-color: rgb(19, 200, 255);
        border: 3px solid rgb(19, 200, 255);
      }
    }
  }
}
/* Medium devices (landscape tablets, 768px and up) */
@media only screen and (min-width: 768px) {
  .application-form {
    .investment-options {
      .custom-control {
        width: 45%;
      }
    }
  }
}
</style>
